import { combineReducers } from "@reduxjs/toolkit";
import appReducer from "./slices/appSlice";

// Legacy reducers are kept as a compatibility bridge so current New pages
// continue to work while being migrated to `app` centralized state.
import employeesReducer from "../../features/employeesSlice";
import legalEmployeesReducer from "../../features/legalEmployeesSlice";
import branchesReducer from "../../features/branchesSlice";
import authorizationReducer from "../../features/authorizationSlice";
import authorizationMobileReducer from "../../features/authorizationMobileSlice";
import responseReducer from "../../features/responseSlice";
import billsPageReducer from "../../features/billsPageSlice";
import transactionDetailsReducer from "../../features/transactionDetailsSlice";
import advancePayrollConfirmReducer from "../../features/AdvancePayrollConfirmPopupSlice";
import quickPayReducer from "../../features/QuickPaySlice";
import statementOfAccountReducer from "../../features/statementOfAccountSlice";
import accountBalanceReducer from "../../features/accountBalanceSlice";
import cfcLoanReducer from "../../features/cfcLoanSlice";
import externalCashReducer from "../../features/ExternalCashDepositSlice";
import webSocketReducer from "../../features/webSocketSlice";
import paymentRequestReducer from "../../features/paymentRequestSlice";
import bobCorporateReducer from "../../features/BOBCorporateSlice";
import bobTransactionDetailsReducer from "../../features/BOBTransactionDetailsSlice";
import appMobileReducer from "../../features/appMobileSlice";
import transferAbroadDetailsReducer from "../../features/transferAbroadDetailsSlice";
import transferCountrySelectionReducer from "../../features/TransferCountrySelectionSlice";
import bankAccountDetailsReducer from "../../features/bankAccountDetailsSlice";
import legalEnrollmentReducer from "../../features/legalEnrollmentSlice";
import cashInAndOutReducer from "../../features/CashInAndOutSlice";
import butlerReducer from "../../features/CashInAndOutSlice";

const rootReducer = combineReducers({
  app: appReducer,
  employees: employeesReducer,
  legalEmployees: legalEmployeesReducer,
  branches: branchesReducer,
  authorization: authorizationReducer,
  authorizationMobile: authorizationMobileReducer,
  transferResponse: responseReducer,
  billsPage: billsPageReducer,
  transactionDetails: transactionDetailsReducer,
  transferAbroadDetails: transferAbroadDetailsReducer,
  advancePayrollConfirm: advancePayrollConfirmReducer,
  quickPay: quickPayReducer,
  statementOfAccount: statementOfAccountReducer,
  accountBalance: accountBalanceReducer,
  cfcLoan: cfcLoanReducer,
  externalCash: externalCashReducer,
  websocket: webSocketReducer,
  paymentRequest: paymentRequestReducer,
  bobCorporate: bobCorporateReducer,
  bobtransactionDetails: bobTransactionDetailsReducer,
  appData: appMobileReducer,
  transferCountrySelection: transferCountrySelectionReducer,
  bankAccountDetails: bankAccountDetailsReducer,
  legalEnrollment: legalEnrollmentReducer,
  cashInAndOut: cashInAndOutReducer,
  ButlerSlice: butlerReducer,
});

export default rootReducer;
